// @flow
import React from 'react';
import Toggle from 'react-toggled';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@material-ui/core/Button';

import keycodes from '../../utils/keycodes';

import ScribeReportModalContainer from './ScribeReportModalContainer';

import Transition from '../../components/Transition';

type Props = {
  conversationEnded?: boolean,
  conversationEndedSuccessfully?: boolean,
  resetConversation: Function,
  conversationEndedMessage?: string,
  currentPlatform: string,
  socketConnected: boolean,
  loading: boolean,
};

export default class ScribeConversationOverModal extends React.Component<Props> {
  // eslint-disable-next-line class-methods-use-this
  nextConversation() {
    const { resetConversation } = this.props;
    // window.location.reload();
    resetConversation();
  }

  handleKeydown = (ev: KeyboardEvent) => {
    const key = keycodes(ev);
    if (key.SPACE) {
      this.nextConversation();
    }
  };

  unsubscribeFromKeydownEvents() {
    document.removeEventListener('keydown', this.handleKeydown, false);
  }

  subscribeToKeydownEvents() {
    document.addEventListener('keydown', this.handleKeydown, false);
  }

  componentWillUnmount() {
    this.unsubscribeFromKeydownEvents();
  }

  render() {
    const {
      conversationEndedSuccessfully,
      conversationEndedMessage,
      conversationEnded,
      currentPlatform,
      socketConnected,
      loading,
    } = this.props;
    const conversationOverDialogText = (() => {
      if (conversationEndedMessage === 'captionCancel')
        return 'Conversation was cancelled';
      if (conversationEndedSuccessfully)
        return 'Conversation ended successfully';
      if (conversationEnded) return 'Conversation ended due to error';
      if (socketConnected === 'DISCONNECTED')
        return 'Connection to the server was lost';
      return '';
    })();

    if (!conversationOverDialogText || loading || currentPlatform === 'web')
      return null;

    return (
      <Toggle>
        {({ on, setOn }) => (
          <Dialog
            open={!on}
            TransitionComponent={Transition}
            keepMounted
            onClose={setOn}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              {conversationOverDialogText}
            </DialogTitle>
            <DialogActions>
              {localStorage.getItem('scribeBackendUrl') ===
                'https://scribe-playground.ava.me' && (
                <Button key="back_convo_btn" onClick={setOn}>
                  Back to conversation
                </Button>
              )}
              <Toggle>
                {({
                  on: onReport,
                  getTogglerProps: getTogglerPropsReport,
                  setOff: setOffReport,
                }) => [
                  <Button
                    key="1"
                    variant="outlined"
                    {...getTogglerPropsReport()}
                  >
                    Report Issue
                  </Button>,
                  <ScribeReportModalContainer
                    key="2"
                    open={onReport}
                    close={setOffReport}
                    old
                    // openEventListener={this.unsubscribeFromKeydownEvents()}
                  />,
                ]}
              </Toggle>
              <Button
                key="next_convo_btn"
                onClick={() => {
                  this.nextConversation();
                }}
                variant="contained"
              >
                Next conversation
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Toggle>
    );
  }
}
